import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCrown = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 14,
	height: 12,
	viewBox: "0 0 14 12",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M13.0561 2.32024L10.0155 4.19368L7.09985 0.304619C7.08812 0.288966 7.07291 0.27626 7.05541 0.267509C7.03792 0.258758 7.01863 0.254202 6.99907 0.254202C6.97951 0.254202 6.96022 0.258758 6.94273 0.267509C6.92523 0.27626 6.91002 0.288966 6.89829 0.304619L3.98423 4.19368L0.942039 2.32024C0.852977 2.26556 0.737351 2.33899 0.751414 2.44368L1.94516 11.5156C1.96235 11.639 2.0686 11.7343 2.19516 11.7343H11.8061C11.9311 11.7343 12.0389 11.6406 12.0545 11.5156L13.2483 2.44368C13.2608 2.33899 13.1467 2.26556 13.0561 2.32024ZM6.99985 9.47181C6.02954 9.47181 5.24048 8.68274 5.24048 7.71243C5.24048 6.74212 6.02954 5.95306 6.99985 5.95306C7.97016 5.95306 8.75923 6.74212 8.75923 7.71243C8.75923 8.68274 7.97016 9.47181 6.99985 9.47181ZM6.99985 6.95774C6.58423 6.95774 6.24673 7.29524 6.24673 7.71243C6.24673 8.12806 6.58423 8.46712 6.99985 8.46712C7.41548 8.46712 7.75298 8.12962 7.75298 7.71243C7.75298 7.29681 7.41548 6.95774 6.99985 6.95774Z",
		fill: "currentColor"
	})
});
export default SvgCrown;
